<template>
	<div class="document p-4">
		<div class="compass-doc-section p-2 mt-3">
			<div class="grid">
				<div class="col-8 document-title">
					<p>Application For Amendment To Compliance Schedule</p>
					<p>Form 11 Section 106</p>
					<p>Building Act 2004 </p>
				</div>
				<div class="col-4 css-image compass-logo mt-2">
				</div>
			</div>
		</div>
		<div class="grid p-2 mt-3">
			<div class="col-6 flex">
				<h6>Project No:</h6>&nbsp;<span>{{propertyData.propertyId}}</span>
			</div>
			<div class="col-6 flex">
				<h6>C.S. No:</h6>&nbsp;<span>{{bwof.complianceSchedule}}</span>
			</div>
		</div>
		<div class="compass-doc-section">
			<div class="header">
				<span>BUILDING DETAILS</span>
			</div>
			<div class="body">
				<b>Building name:</b><span>&nbsp;{{propertyData.propertyName}}</span><br />
				<b>Street address of building:</b><span>&nbsp;{{propertyData.streetAddress}} {{propertyData.suburb}} {{propertyData.city}}</span><br />
				<b>Legal description of land where building is located:</b><span>&nbsp;{{bwof.legalDescription}}</span><br />
				<b>Location of building within site:</b><span>&nbsp;{{bwof.locationOfBuildingWithinSite}}</span><br />
				<b>Current, lawfully established use:</b><span>&nbsp;{{bwof.buildingUse}}</span><br />
				<b>Year first constructed:</b><span>&nbsp;{{bwof.firstConstructed}}</span><br />
				<b>Intended life of the building if 50 years or less:</b><span>&nbsp;{{bwof.intendedLifeOfTheBuilding}}</span><br />
				<b>Purpose group:</b><span>&nbsp;{{bwof.purposeGroup}}</span><br />
				<b>Highest fire hazard category for building use:</b><span>&nbsp;{{bwof.highestFireHazardCategoryFhcNumber}}</span><br />
				<b>Maximum No. of occupants:</b><span>&nbsp;{{bwof.maximumNumberOfOccupants}}</span><br />
			</div>
		</div>
		<div class="compass-doc-section">
			<div class="header">
				<span>OWNER DETAILS</span>
			</div>
			<div class="body">
				<b>Name:</b><span>&nbsp;{{owner.companyName}}</span><br />
				<b>Mailing address:</b>
				<span>
					&nbsp;{{owner.streetAddress}}
					&nbsp;{{owner.postalAddress}}
					&nbsp;{{owner.suburb}}
					&nbsp;{{owner.city}}
				</span><br />
				<b>Contact name:</b><span>&nbsp;{{contact.firstName}}&nbsp;{{contact.lastName}}</span><br />
				<b>Contact phone:</b><span>&nbsp;</span><br />
				<b>Contact mobile:</b><span>&nbsp;{{contact.mobile}}</span><br />
				<b>Contact email:</b><span>&nbsp;{{contact.email}}</span><br />
			</div>
		</div>
		<div class="compass-doc-section">
			<div class="header">
				<span>AGENT DETAILS</span>
			</div>
			<div class="body">
				<template v-if="agent">
					<div class="grid">
						<div class="col-6 pt-2">
							<!--<template v-if="bwof.issuedBy == 'Keith'">-->
							<b>Name of agent:</b><span>&nbsp;Compass New Zealand Limited</span><br />
							<b>Contact person:</b><span v-if="bwof.issuedBy == 'John'">&nbsp;John Bell</span><span v-else>&nbsp;Keith Flatt</span><br />
							<b>Phone:</b><span>&nbsp;09 477 2720</span><br />
							<b>Relationship to owner:</b><span>&nbsp;Owner authorised agent </span><br />
							<!--</template>-->
						</div>
						<div class="col6 pt-2">
							<b>Mailing address:</b><span>&nbsp;PO Box 303 484 North Harbour 0751</span><br />
							<b>Email:</b><span>&nbsp;bwof@compassnzl.co.nz</span><br />
						</div>
					</div>
				</template>
			</div>
		</div>
		<div class="compass-doc-section">
			<div class="header">
				<span>APPLICATION</span>
			</div>
			<div class="body">
				<p>I request that the compliance schedule for the above building be amended as follows: signify by Delete or Add.</p>
				<div class="m-3">
					<div class="grid">
						<div class="col-5 doc-border">
							<b>Specified System for amendment</b>
						</div>
						<div class="col-3 doc-border">
							<b>Amendment</b>
						</div>
						<div class="col-4 doc-border">
							<b>Reason</b>
						</div>
					</div>
					<div class="grid" v-for="(n,i) in textInput.length" :key="i">
						<div class="col-5 doc-border">
							<div contenteditable="true" class="compliance-comment p-inputtext" />
						</div>
						<div class="col-3 doc-border">
							<div contenteditable="true" class="compliance-comment p-inputtext" />
						</div>
						<div class="col-4 doc-border">
							<div contenteditable="true" class="compliance-comment p-inputtext" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="compass-doc-section p-2 mt-3">
			<template v-if="bwof.issuedBy && bwof.issuedBy.trim()">
				<div class="grid mt-1">
					<div class="col-5 flex flex-nowrap">
						Signature of agent on behalf of and with the authority of the owner:
					</div>
					<div class="document-text-border col mr-4 mt-1 css-image" v-bind:class="[bwof.issuedBy == 'John' ? 'signature-john':'signature-keith' ]">
					</div>
				</div>
				<div class="grid mt-1">
					<div class="col-1 flex flex-nowrap">
						Name:&nbsp;
					</div>
					<div class="document-text-border col mr-3 pl-2">
						<span v-if="bwof.issuedBy == 'John'">John Bell</span>
						<span v-else>Keith Flatt</span>
					</div>
				</div>
				<div class="grid mt-1">
					<div class="col-1 flex flex-nowrap">
						Position:&nbsp;
					</div>
					<div class="document-text-border col mr-3 pl-2">
						<span v-if="bwof.issuedBy == 'John'">General Manager (Compass New Zealand Ltd)</span>
						<span v-else>Managing Director (Compass New Zealand Ltd)</span>
					</div>
				</div>
				<div class="grid mt-1">
					<div class="col-1 flex flex-nowrap">
						Date:&nbsp;
					</div>
					<div class="document-text-border col mr-3 pl-2">
						{{formattedDate(bwof.bwofIssuedDate ?? new Date())}}
					</div>
				</div>
			</template>
			<template v-else>
				<div class="grid mt-1 align-items-center">
					<div class="col-2 flex">
						Signature of owner:
					</div>
					<div class="document-text-border col mr-4 mt-1 css-image signature-box" @click="displaySignatureModal = true"
							:style="{ backgroundImage: `url('data:image/png;base64,${ownerSignatureBase64}')` }">
					</div>
				</div>
				<div class="grid mt-1">
					<div class="col-2 flex flex-nowrap">
						Name:&nbsp;
					</div>
					<div class="document-text-border col mr-3 pl-2" contenteditable="true">
					</div>
				</div>
				<div class="grid mt-1">
					<div class="col-2 flex flex-nowrap">
						Date:&nbsp;
					</div>
					<div class="document-text-border col mr-3 pl-2" contenteditable="true">
						{{formattedDate(new Date())}}
					</div>
				</div>
			</template>
		</div>
	</div>

	<SignatureModal :open="displaySignatureModal"
					:signatureBase64="ownerSignatureBase64"
					@close="displaySignatureModal=false"
					@updateSignature="updateSignature"/>
</template>

<script lang="ts">
	import { Vue, Options } from 'vue-class-component';
	import { PropertyData, PropertyServiceData, CompanyData, ContactData, PropertyBwofData } from '@/api-client/api-client'
	import { format, isValid } from 'date-fns';
	import SignatureModal from '../SignatureModal.vue';

	@Options({
		name: 'DocumentBwof',
		components: {
			SignatureModal
		},
		props: {
			propertyData: null
		}
	})
	export default class ComplianceTemplate extends Vue {

		// Data
		propertyData: PropertyData = new PropertyData();

		parentBwofService: PropertyServiceData = new PropertyServiceData();

		bwofServices: PropertyServiceData[] = [];

		bwof: PropertyBwofData = new PropertyBwofData();

		owner: CompanyData = new CompanyData();

		contact: ContactData = new ContactData();

		agent: ContactData = new ContactData();

		textInput = [['', '', ''], ['', '', ''], ['', '', ''], ['', '', '']]

		displaySignatureModal = false;

		ownerSignatureBase64 = '';

		ownerSignatureDateString = '';

		created() {
			// The Bwof service -- assuming that a property will only have 1 Bwof service
			this.parentBwofService = this.propertyData.services != null ? this.propertyData.services.filter(service => service.serviceId == 1 && service.active == true && service.whenDeleted == null)[0] : this.parentBwofService;

			this.bwof = this.propertyData.propertyBwof != null ? this.propertyData.propertyBwof : this.bwof;
			this.owner = this.propertyData.owner != null ? this.propertyData.owner : this.owner;

			// Set Owner Contact from BWOF
			this.contact = this.bwof.ownerContact != null ? this.bwof.ownerContact : this.contact;

			//this.agent = this.bwof.issuedBy;
		}

		formattedDate(date: Date) {
			if (!isValid(date)) return;

			return format(date, 'd MMMM yyyy');
		}

		updateSignature(base64: string) {
			this.ownerSignatureBase64 = base64;
		}
	}
</script>

<style>
	.compliance-comment {
		height: 210px;
		resize: vertical;
		overflow: auto;
		word-break: break-word;
		font-size: 10px !important;
	}
</style>